import { TwoColumnBox } from "Components/TwoColumnBox";
import { Athlete } from "./Athlete";
import { useEffect, useState } from "react";
import { Collapse, Flex, Form } from "antd";
import { AwardsAndRecognition } from "./AwardsAndRecognition";
import { CollegeName } from "./CollegeName";
import { LevelofEducation } from "./Level";
import { Branch } from "./Branch";
import { InputBox } from "Components/TextInputBox";
import { Typography } from "antd";

const { Title } = Typography;

const highSchoolFieldsWithSections = {
  "Grade 9": [
    "Grade 9 Unweighted GPA",
    "Grade 9 Weighted GPA",
    "Grade 9 Class Rank",
    "Grade 9 Number of Honors/AP/IB/Dual Courses Taken",
  ],
  "Grade 10": [
    "Grade 10 Unweighted GPA",
    "Grade 10 Weighted GPA",
    "Grade 10 Class Rank",
    "Grade 10 Number of Honors/AP/IB/Dual Courses Taken",
  ],
  "Grade 11": [
    "Grade 11 Unweighted GPA",
    "Grade 11 Weighted GPA",
    "Grade 11 Class Rank",
    "Grade 11 Number of Honors/AP/IB/Dual Courses Taken",
  ],
  "Grade 12": [
    "Grade 12 Unweighted GPA",
    "Grade 12 Weighted GPA",
    "Grade 12 Class Rank",
    "Grade 12 Number of Honors/AP/IB/Dual Courses Taken",
  ],
  "Cumulative Scores": ["Cumulative High School GPA"],
};

const highSchoolFields = [
  { label: "High school name", field: "High School Name" },
  { label: "High school location", field: "High School Address" },
];

export const EducationAndExperience = ({ form }) => {
  const [athleteDetails, setAthleteDetails] = useState({
    isAthlete: form.getFieldValue("isAthlete"),
    athleteSport: form.getFieldValue("athleteSport"),
    athleteLevel: form.getFieldValue("athleteLevel"),
  });
  const [awardsDetails, setAwardsDetails] = useState({
    hasAwards: form.getFieldValue("hasAwards"),
    awardName: form.getFieldValue("awardName"),
    awardLevel: form.getFieldValue("awardLevel"),
  });
  const [previousEducation, setPreviousEducation] = useState({
    prevEdCollegeName: form.getFieldValue("prevEdCollegeName"),
    prevEdLevel: form.getFieldValue("prevEdLevel"),
    prevEdBranch: form.getFieldValue("prevEdBranch"),
    prevEdCGPA: form.getFieldValue("prevEdCGPA"),
  });
  const [workExperience, setWorkExperience] = useState({
    workExperienceYears: form.getFieldValue("workExperienceYears"),
    workExperienceIndustry: form.getFieldValue("workExperienceIndustry"),
  });

  useEffect(() => {
    if (!form.getFieldValue("isAthlete")) {
      form.setFieldsValue({
        isAthlete: false,
      });
    }
    if (!form.getFieldValue("hasAwards")) {
      form.setFieldsValue({
        hasAwards: false,
      });
    }
  }, [form]);

  const slug = (s) =>
    s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_|_$/g, "");

  return (
    <TwoColumnBox
      rightElement={
        <Flex vertical>
          <Form.Item
            name="isAthlete"
            rules={[
              {
                required: true,
                message: "Please select if you are an athlete",
              },
              {
                validator: (_, value) => {
                  if (
                    value &&
                    (!athleteDetails.athleteLevel ||
                      !athleteDetails.athleteSport)
                  ) {
                    return Promise.reject(
                      new Error("Please select a sport and level"),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Athlete
              isAthlete={athleteDetails.isAthlete}
              setIsAthlete={(value) => {
                if (!value) {
                  setAthleteDetails((prev) => ({
                    ...prev,
                    athleteLevel: "",
                    athleteSport: "",
                  }));
                  form.setFieldsValue({
                    athleteSport: undefined,
                    athleteLevel: undefined,
                  });
                }
                setAthleteDetails((prev) => ({ ...prev, isAthlete: value }));
                form.setFieldsValue({ isAthlete: value });
              }}
              sport={athleteDetails.athleteSport}
              setSport={(value) => {
                setAthleteDetails((prev) => ({ ...prev, athleteSport: value }));
                form.setFieldsValue({ athleteSport: value });
              }}
              level={athleteDetails.athleteLevel}
              setLevel={(value) => {
                setAthleteDetails((prev) => ({ ...prev, athleteLevel: value }));
                form.setFieldsValue({ athleteLevel: value });
              }}
            />
          </Form.Item>
          <Form.Item
            name="hasAwards"
            rules={[
              {
                required: true,
                message: "Please select if you have received any awards",
              },
              {
                validator: (_, value) => {
                  if (
                    value &&
                    (!awardsDetails.awardName || !awardsDetails.awardLevel)
                  ) {
                    return Promise.reject(
                      new Error("Please select an award and level"),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <AwardsAndRecognition
              receivedAwards={awardsDetails.hasAwards}
              setReceiveAwards={(value) => {
                if (!value) {
                  setAwardsDetails((prev) => {
                    return { ...prev, awardLevel: "", awardName: "" };
                  });
                  form.setFieldsValue({
                    awardName: undefined,
                    awardLevel: undefined,
                  });
                }
                setAwardsDetails((prev) => ({ ...prev, hasAwards: value }));
                form.setFieldsValue({ hasAwards: value });
              }}
              awardName={awardsDetails.awardName}
              setAwardName={(value) => {
                setAwardsDetails((prev) => ({ ...prev, awardName: value }));
                form.setFieldsValue({ awardName: value });
              }}
              level={awardsDetails.awardLevel}
              setLevel={(value) => {
                setAwardsDetails((prev) => ({ ...prev, awardLevel: value }));
                form.setFieldsValue({ awardLevel: value });
              }}
            />
          </Form.Item>
        </Flex>
      }
      leftElement={
        form.getFieldValue("applyingProgram") === "Bachelors" ? (
          <Flex vertical>
            {highSchoolFields.map(({ label, field }, index) => (
              <Form.Item
                name={field.replace(" ", "")}
                rules={[{ required: true, message: `Please enter ${field}` }]}
                key={index}
                className="text-left"
              >
                <Title style={{ fontSize: "18px", fontWeight: "500" }}>
                  {label}
                </Title>
                <InputBox
                  placeholder={label}
                  value={form.getFieldValue(field.replace(" ", ""))}
                  onChange={(value) => {
                    form.setFieldsValue({ [field.replace(" ", "")]: value });
                  }}
                  required={true}
                  widthSize={"large"}
                  heightSize="small"
                />
              </Form.Item>
            ))}
            {Object.entries(highSchoolFieldsWithSections).map(
              ([section, fields]) => {
                const sectionKey = slug(section);
                return (
                  <Collapse
                    key={sectionKey}
                    className="bg-white border border-gray-200 rounded-lg text-left m-1"
                    expandIconPosition="end"
                    items={[
                      {
                        key: `${sectionKey}-panel`,
                        label: (
                          <span className="font-semibold text-gray-800 text-lg">
                            {section}
                          </span>
                        ),
                        children: (
                          <div className="flex flex-col">
                            {fields.map((field, index) => (
                              <Form.Item
                                name={field.replace(" ", "")}
                                rules={[
                                  {
                                    required: true,
                                    message: `Please enter ${field}`,
                                  },
                                ]}
                                key={index}
                                className="text-left"
                              >
                                <Title
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {field}
                                </Title>
                                <InputBox
                                  placeholder={field}
                                  value={form.getFieldValue(
                                    field.replace(" ", ""),
                                  )}
                                  onChange={(value) => {
                                    form.setFieldsValue({
                                      [field.replace(" ", "")]: value,
                                    });
                                  }}
                                  required={true}
                                  widthSize={"large"}
                                  heightSize="small"
                                />
                              </Form.Item>
                            ))}
                          </div>
                        ),
                      },
                    ]}
                  />
                );
              },
            )}
          </Flex>
        ) : (
          <Flex vertical>
            <Form.Item
              name="prevEdCollegeName"
              rules={[{ required: true, message: "Please select a college" }]}
            >
              <CollegeName
                selectedCollege={previousEducation.prevEdCollegeName}
                setCollege={(value) => {
                  setPreviousEducation((prev) => ({
                    ...prev,
                    prevEdCollegeName: value,
                  }));
                  form.setFieldsValue({ prevEdCollegeName: value });
                }}
              />
            </Form.Item>
            <Form.Item
              name="prevEdLevel"
              rules={[{ required: true, message: "Please select a level" }]}
            >
              <LevelofEducation
                selectedCard={previousEducation.prevEdLevel}
                setSelectedCard={(value) => {
                  setPreviousEducation((prev) => ({
                    ...prev,
                    prevEdLevel: value,
                  }));
                  form.setFieldsValue({ prevEdLevel: value });
                }}
              />
            </Form.Item>
            <Form.Item
              name="prevEdBranch"
              rules={[{ required: true, message: "Please select a branch" }]}
            >
              <Branch
                selectedBranch={previousEducation.prevEdBranch}
                setBranch={(value) => {
                  setPreviousEducation((prev) => ({
                    ...prev,
                    prevEdBranch: value,
                  }));
                  form.setFieldsValue({ prevEdBranch: value });
                }}
              />
            </Form.Item>
            <Form.Item
              name="workExperienceYears"
              rules={[
                { required: true, message: "Please enter years of experience" },
              ]}
            >
              <Title
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                Work experience (years)
              </Title>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <InputBox
                  placeholder="e.g., 3"
                  value={workExperience.workExperienceYears}
                  onChange={(value) => {
                    setWorkExperience((prev) => ({
                      ...prev,
                      workExperienceYears: value,
                    }));
                    form.setFieldsValue({ workExperienceYears: value });
                  }}
                  required={true}
                  style={{ width: "100%", alignItems: "flex-start" }}
                  heightSize="small"
                />
              </div>
            </Form.Item>
            <Form.Item
              name="workExperienceIndustry"
              rules={[
                { required: true, message: "Please enter your industry" },
              ]}
            >
              <Title
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                Work industry
              </Title>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <InputBox
                  placeholder="e.g., Software, Finance, Consulting"
                  value={workExperience.workExperienceIndustry}
                  onChange={(value) => {
                    setWorkExperience((prev) => ({
                      ...prev,
                      workExperienceIndustry: value,
                    }));
                    form.setFieldsValue({ workExperienceIndustry: value });
                  }}
                  required={true}
                  widthSize="large"
                  heightSize="small"
                />
              </div>
            </Form.Item>
          </Flex>
        )
      }
    />
  );
};
